import { clsxm } from '@app/styles/clsxm';
import { LinearProgress } from '@mui/material';

export const SmartProgressBar: React.FC<{
  value?: number | null;
  max?: number | null;
  className?: string;
  isReachingLimit?: boolean;
}> = ({ value = 0, max = 0, className, isReachingLimit }) => {
  const progress = max ? (100 * (value || 0)) / max : 0;

  const isLimitReached = max === null ? false : (value || 0) >= max;

  return (
    <div>
      <LinearProgress
        className={clsxm((isLimitReached || isReachingLimit) && 'text-red-500')}
        classes={{ root: clsxm('rounded h-[6px] bg-accept-menu-item', className), bar: clsxm('rounded') }}
        variant="determinate"
        color={isLimitReached || isReachingLimit ? 'inherit' : 'primary'}
        value={progress}
      />
    </div>
  );
};
